import z from 'zod';

export const resetPasswordSearchSchema = z.object({
    token: z.string().min(1),
});
